import Vue from 'vue';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';

Vue.component('form-checkbox', {
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
    },
    methods: {
        ...methods,
        sync(prop, value) {
            if (!(prop in this.cmodel))
                Vue.set(this.cmodel, prop, value);
            else
                this.cmodel[prop] = value;
        }
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        schema: null,
        cmodel: null,
        readonly: false,
        child: 0,
    },
    render(h) {
        if (!this.Condition)
            return null;

        let desc;
        if (this.schema.description)
            desc = <i class="mdi mdi-information" title={this.schema.description} style={{ color: "silver", fontSize: "small", marginLeft: "3px" }}></i>;

        const name = <span style={{ marginLeft: (this.child * 15) + "px" }}>{this.name}</span>;
        let input;

        if (this.readonly)
            input = <input type="checkbox" checked={this.cmodel[this.schemakey]} disabled="disabled" />;
        else
            input = <input type="checkbox" checked={this.cmodel[this.schemakey]} on-change={(e) => this.sync(this.schemakey, e.target.checked)} />;

        return (
            <tr>
                <td style={{ width: "1px" }}>
                    {name} {desc}
                </td>
                <td>
                    {input}
                </td>
            </tr>
        );
    }
});